import { Alert, Snackbar } from "@mui/material";
import React, { createContext, useState, useContext } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const SnackbarContext = createContext();

export const SnackbarProvider = ({ children }) => {
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    type: "info", // e.g., 'success', 'error', 'warning'
  });

  const openSnackbar = (message, type = "info") => {
    setSnackbarState({ open: true, message, type });
  };

  const closeSnackbar = () => {
    setSnackbarState((prevState) => ({ ...prevState, open: false }));
  };

  const getIcon = (type) => {
    switch (type) {
      case "success":
        return <CheckCircleIcon />;
      default:
        return null;
    }
  };

  const icon = getIcon(snackbarState.type);

  return (
    <SnackbarContext.Provider
      value={{ snackbarState, openSnackbar, closeSnackbar }}
    >
      {children}
      <Snackbar
        open={snackbarState.open}
        autoHideDuration={6000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          icon={icon}
          onClose={closeSnackbar}
          severity={snackbarState.type}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbarState.message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => {
  return useContext(SnackbarContext);
};
